import React from 'react';
import { Route } from 'react-router-dom';
import { StepContext } from '../contexts';
import { useStep } from './useStep';

export type StepProviderProps = {
  children: React.ReactNode;
};

const StepProvider = ({ children }: StepProviderProps): JSX.Element => {
  const wizardStep = useStep();

  return <StepContext.Provider value={wizardStep}>{children}</StepContext.Provider>;
};

const toStepProvider = (child: React.ReactNode, i: number): JSX.Element => {
  const stepName = `step${i + 1}`;
  return (
    <Route exact path={stepName} key={stepName}>
      <StepProvider>{child}</StepProvider>
    </Route>
  );
};

export { StepProvider, toStepProvider };
